/**
 * Fixed Video Background
 *
 * Sticky video background that stays in place while content scrolls over it
 */

const FixedVideoBackground = () => {
  return (
    <div className="fixed inset-0 w-full h-full -z-10">
      {/* VIDEO BACKGROUND: Looping hologram video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full"
        style={{
          objectFit: "cover",
          objectPosition: "center top",
          minWidth: "100%",
          minHeight: "100%",
        }}
      >
        <source src="/hero-video.mp4" type="video/mp4" />
      </video>

      {/* DARK OVERLAY: Subtle overlay to make video visible but not overwhelming */}
      <div className="absolute inset-0 bg-black/40" />
    </div>
  );
};

export default FixedVideoBackground;
